import { useQuery } from '@tanstack/react-query'
import { storesClient } from '../services/storesClient'
import { useParams, useSearchParams } from 'react-router-dom'
import { useStore as useStoreState } from 'state'
import { validateBrowserLang } from '../utils/browserDetectUtils'

export function useStore() {
  const { storeId } = useParams()
  const [searchParams] = useSearchParams()
  const browserLang = searchParams.get('lang')
  const { setStore } = useStoreState()
  return useQuery({
    queryKey: ['store', storeId],
    queryFn: async () => {
      const response = await storesClient.get(`/stores/${storeId}`)

      const lang = validateBrowserLang(browserLang) ?? response.data.lang
      setStore({ ...response.data, lang })

      const store = response.data
      return { ...store, lang }
    },
    enabled: !!storeId,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })
}
